import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IResultPackageSummaryPayload } from '../../../types';

/**
 * This is to track Package Details from the backend.
 */
export const PACKAGE_DETAILS_QUERY_KEY = 'package-details-query-key';

/**
 * This hook fetches list of package details from mock APi.
 */
export const usePackageDetailsQuery = (
  payload: IResultPackageSummaryPayload
) => {
  const { inventoryId, appraisalCode } = payload;
  const { data, isError, error, isPending, isFetching, refetch } =
    useQueryWithUserId({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: [PACKAGE_DETAILS_QUERY_KEY, inventoryId, appraisalCode],
      networkMode: 'always',
      retry: false,
      queryFn: () => INV_MGMT_SERVICE_API.getPackageDetails(payload),
    });

  return {
    error,
    isError,
    data,
    isFetching,
    isPending,
    refetch,
  };
};
